import clsx from 'clsx'
import { TEAM_PILL } from 'lib/community/discussions'
import styles from './Discussions.module.css'

/** The check in the pill (stroke, inherits the pill's text colour). */
const Check: React.VFC = () => (
  <svg
    className={styles.teamPillCheck}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={3}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M20 6 9 17l-5-5" />
  </svg>
)

/**
 * The SOUNDGUYS TEAM pill (SoundGuys team in discussions, 2026-10-09): on an answer whose author
 * is a team profile (`decorate`, `size="answer"`), on a card's "answered" footer and the thread's
 * status line (`size="small"`). The text is "SoundGuys team" (uppercased by CSS) — reader-facing,
 * never "staff".
 */
const TeamPill: React.VFC<{ size?: 'answer' | 'small'; check?: boolean }> = ({
  size = 'small',
  check = true,
}) => (
  <span className={clsx(styles.teamPill, { [styles.teamPillAnswer]: size === 'answer' })}>
    {check && <Check />}
    {TEAM_PILL}
  </span>
)

export default TeamPill
